import { slideDown, slideUp, slideToggle, toggleClass } from './common';
const facetFilerAccordion = () => {
  const accWrapper = '.e-div--rc-filter-accordion';
  const activeClass = 'e-div--rc-active';
  const handleElement = 'h3';
  const toggleBody = '.facetwp-facet';
  const accList = Array.from( document.querySelectorAll( accWrapper ) );

  if( accList.length === 0 ) return;
  
  const isMobile = window.innerWidth < 992;

  for ( const element of accList ) {
    const body = element.querySelector( toggleBody );

    if ( isMobile ) {
      element.classList.remove( activeClass );
      slideUp( body );
    } else {
      if ( element.classList.contains( activeClass ) ) {
        slideDown( body );
      } else {
        slideUp( body );
      }
    }
    
    const handle = element.querySelector( handleElement );
    handle.addEventListener( 'click', () => {
      slideToggle( body );
      toggleClass( element, activeClass );
    } );
  }
  
};

facetFilerAccordion();
